/**
 * The numeric enums behind membership plans and their benefits.
 *
 * Verbatim from `utils/functions.js` (`mapSubscriptionRecurrence`,
 * `mapSubscriptionBenefitType`, `eventTypes`), which expressed each as a chain
 * of `if (x === n) return 'key'`.
 */

export const RECURRENCE = [
  { value: 0, labelKey: 'memberships.recurrenceOptions.none' },
  { value: 1, labelKey: 'memberships.recurrenceOptions.daily' },
  { value: 2, labelKey: 'memberships.recurrenceOptions.weekly' },
  { value: 3, labelKey: 'memberships.recurrenceOptions.biweekly' },
  { value: 4, labelKey: 'memberships.recurrenceOptions.monthly' },
  { value: 5, labelKey: 'memberships.recurrenceOptions.bimonthly' },
  { value: 6, labelKey: 'memberships.recurrenceOptions.quarterly' },
  { value: 7, labelKey: 'memberships.recurrenceOptions.semiyearly' },
  { value: 8, labelKey: 'memberships.recurrenceOptions.yearly' },
] as const;

export function recurrenceLabelKey(value: number | null | undefined) {
  return (
    RECURRENCE.find((option) => option.value === value)?.labelKey ??
    'memberships.recurrenceOptions.none'
  );
}

export const BENEFIT_TYPE = [
  { value: 0, labelKey: 'memberships.benefitType.fixedDiscount' },
  { value: 1, labelKey: 'memberships.benefitType.percentDiscount' },
  { value: 2, labelKey: 'memberships.benefitType.specialPrice' },
  { value: 3, labelKey: 'memberships.benefitType.free' },
  { value: 4, labelKey: 'memberships.benefitType.earlyVisibility' },
  { value: 5, labelKey: 'memberships.benefitType.posFixedDiscount' },
  { value: 6, labelKey: 'memberships.benefitType.posPercentDiscount' },
] as const;

export function benefitTypeLabelKey(value: number | null | undefined) {
  return (
    BENEFIT_TYPE.find((option) => option.value === value)?.labelKey ??
    'memberships.benefitType.fixedDiscount'
  );
}

/** Whether a benefit's amount is money, a percentage, or not used at all. */
export function benefitAmountUnit(type: number | null | undefined) {
  if (type === 0 || type === 2 || type === 5) return '($)';
  if (type === 1 || type === 6) return '(%)';
  return '';
}

export const EVENT_TYPES = [
  { value: 0, labelKey: 'memberships.eventType.rental' },
  { value: 1, labelKey: 'memberships.eventType.class' },
  { value: 2, labelKey: 'memberships.eventType.other' },
  { value: 3, labelKey: 'memberships.eventType.yoga' },
  { value: 4, labelKey: 'memberships.eventType.service' },
  { value: 5, labelKey: 'memberships.eventType.none' },
] as const;

/** Promo date extension, in whole units. */
export const DATE_EXTENSION_TYPE = [
  { value: 0, labelKey: 'memberships.extension.none' },
  { value: 1, labelKey: 'memberships.extension.days' },
  { value: 2, labelKey: 'memberships.extension.weeks' },
  { value: 3, labelKey: 'memberships.extension.months' },
  { value: 4, labelKey: 'memberships.extension.years' },
] as const;

export const DISCOUNT_TYPE = [
  { value: 0, labelKey: 'memberships.discountType.fixed' },
  { value: 1, labelKey: 'memberships.discountType.percentage' },
] as const;
